export const TIPOTEXTO_ENUM = {
    TEXTO: 1,
    TITULO: 2,
    LINHA: 3,
    CONTADOR: 4,
  };